import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CertificatesComponent } from './pages/certificates/certificates.component';
import { OriginCertificateComponent } from './pages/certificates-origin/origin-certificate.component';
import { NewOriginCertificateComponent } from './pages/new-origin-certificate/new-origin-certificate.component';
import { OriginCertificateDetailComponent } from './pages/origin-certificate-detail/origin-certificate-detail.component';

const routes: Routes = [
  {
    path: '',
    component: CertificatesComponent,
    children: [
      {
        path: '',
        redirectTo: 'Certificateorigin',
        pathMatch: 'full',
        data: {
          breadcrumb: 'easy-trade.certificates.self'
        }
      },
      {
        path: 'Certificateorigin',
        component: OriginCertificateComponent,
        data: {
          breadcrumb: 'easy-trade.certificates.origin'
        }
      },
      {
        path: 'Certificateorigin/NewCertificateorigin',
        component: NewOriginCertificateComponent,
        data: {
          breadcrumb: 'easy-trade.certificates.new-origin'
        }
      },
      {
        path: 'Certificateorigin/EditOriginCertificate/:id',
        component: NewOriginCertificateComponent,
        data: {
          breadcrumb: 'easy-trade.certificates.edit-origin'
        }
      },
      {
        path: 'Certificateorigin/DetailOriginCertificate/:id',
        component: OriginCertificateDetailComponent,
        data: {
          breadcrumb: 'easy-trade.certificates.detail-origin'
        }
      }
    ]
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CertificatesRoutingModule {}
